import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  ModalBody,
  Box,
  Flex,
  Text,
} from '@chakra-ui/react';
import ModalHeaderComponent from '../../../../components/ModalHeader';
import './LessonModal.scss';

export default function LessonModal({ onClose, modalData }: any) {
  const closeModal = () => {
    onClose('lessonModal', '');
  };

  const { lesson_day, start_time, end_time, note, feedback, teacher } = modalData || {};

  return (
    <Modal isOpen={true} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent minW="55rem">
        <ModalHeaderComponent title={'直近に実施したレッスン'} />
        <ModalBody>
          {modalData && Object.keys(modalData).length > 0 ? (
            <>
              <Flex direction={'column'}>
                <Text fontWeight={'bold'}>日時</Text>
                <Text>
                  {lesson_day}　{start_time}～{end_time}
                </Text>
              </Flex>

              <Flex direction={'column'} mt={5}>
                <Text fontWeight={'bold'}>担当教師</Text>
                <Text>{teacher}</Text>
              </Flex>

              <Box mt={5} maxW="30%" overflowY="auto">
                <Text fontWeight={'bold'}>フィードバック</Text>
              </Box>
              <p className={feedback ? 'Feedback-details' : 'Feedback-details-readOnly'}>
                {feedback || 'フィードバックが入力されていません'}
              </p>
            </>
          ) : (
            <Flex direction={'column'} justifyContent="center" alignItems="center" py={10}>
              <Text fontSize="lg">データはありません</Text>
            </Flex>
          )}
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
}
